import { Container } from 'unstated';

import _ from 'lodash';
import { Promise } from 'es6-promise';

class WineHistoryContainer extends Container {
  constructor(serviceContainer, props = {}) {
    super(props);

    this.serviceContainer = serviceContainer;
    this.customerService = serviceContainer.customerService;
    this.presenceService = serviceContainer.presenceService;
    this.saleHistoryService = serviceContainer.saleHistoryService;
    this.ratingService = serviceContainer.ratingService;
    this.wineMetadataService = serviceContainer.wineMetadataService;

    this.state = {
      history: undefined
    };
  }

  reset() {
    this.setState({ history: undefined });
  }

  async all(onPage) {
    const results = await this.customerService.fetch(onPage);
    this.state.history = results;
    return results;
  }

  async saveRating(productId, rating, notes) {
    const newRating = await this.ratingService.persist(
      productId,
      rating,
      notes
    );
    console.log('saved rating ', newRating);

    if (this.state.history) {
      const products = _.get(this, 'state.history.data.productHistory');
      const product = (products || []).find(({ id }) => id === productId);
      if (product) {
        product.rating = newRating;
      }
    }
    return newRating;
  }
}

export { WineHistoryContainer };
